function toConsole(level, payload) {
  if (typeof payload !== "object" || payload === null) {
    if (level === "error") console.error(payload);
    else if (level === "warn") console.warn(payload);
    else console.log(payload);
    return;
  }
  const { message, ...rest } = payload;
  const prefix = `[${String(payload.level || level).toUpperCase()}]`;
  const line = message != null && message !== "" ? `${prefix} ${message}` : prefix;
  const extra = Object.keys(rest).length ? rest : undefined;
  if (level === "error") console.error(line, extra ?? "");
  else if (level === "warn") console.warn(line, extra ?? "");
  else console.log(line, extra ?? "");
}

export function logEvent(level, message, meta = {}) {
  const payload = {
    ts: new Date().toISOString(),
    level,
    message,
    ...meta,
  };
  toConsole(level, payload);
}

export function captureError(error, context = {}) {
  const err = error instanceof Error ? error : new Error(String(error || "Unknown error"));
  logEvent("error", err.message, {
    name: err.name,
    stack: err.stack,
    context,
  });
  if (typeof window !== "undefined" && window.Sentry?.captureException) {
    window.Sentry.captureException(err, { extra: context });
  }
}
